var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApproved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Check/Duotone"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66675 7.99999C1.66675 4.50219 4.50228 1.66666 8.00008 1.66666C11.4979 1.66666 14.3334 4.50219 14.3334 7.99999C14.3334 11.4978 11.4979 14.3333 8.00008 14.3333C4.50228 14.3333 1.66675 11.4978 1.66675 7.99999ZM8.00008 2.33332C4.87047 2.33332 2.33341 4.87038 2.33341 7.99999C2.33341 11.1296 4.87047 13.6667 8.00008 13.6667C11.1297 13.6667 13.6667 11.1296 13.6667 7.99999C13.6667 4.87038 11.1297 2.33332 8.00008 2.33332Z",
    fill: "#02AC5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.00008 7.99999C2.00008 4.68628 4.68637 1.99999 8.00008 1.99999C11.3138 1.99999 14.0001 4.68628 14.0001 7.99999C14.0001 11.3137 11.3138 14 8.00008 14C4.68637 14 2.00008 11.3137 2.00008 7.99999Z",
    fill: "#02AC5B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.687 5.77977C11.8822 5.97503 11.8822 6.29161 11.687 6.48688L7.0203 11.1535C6.92097 11.2529 6.78443 11.3058 6.64409 11.2995C6.50376 11.2931 6.37257 11.228 6.28264 11.1201L3.9493 8.32008C3.77252 8.10794 3.80118 7.79266 4.01332 7.61588C4.22546 7.4391 4.54074 7.46776 4.71753 7.6799L6.70035 10.0593L10.9799 5.77977C11.1751 5.58451 11.4917 5.58451 11.687 5.77977Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproved);
export default __webpack_public_path__ + "static/media/approved.2b60d0249c61413958f65266470199bf.svg";
export { ForwardRef as ReactComponent };